import editProject from '$src/api/endpoints/projects/editProject'
import {Component, React, observer, resolveCss} from '$src/handy'
import * as css from './CreateProjectModal.css'
import GenericModal from '$src/common/GenericModal'
import {Form} from '$src/common/forms'
import TextInput from '$src/common/TextInput'
import GenericButton from '$src/common/GenericButton'
import DateInput from '$src/common/DateInput'
import {getSnapshot} from 'mobx-state-tree'
import moment from 'moment'
import MultiSelectInput from '$src/common/MultiSelectInput'
import {IStore} from '$src/bootstrap/Store'

interface Props {
  onRequestClose: Function
  projectId: number
  onUpdateNeeded: Function
}

@observer
export default class EditProjectModal extends Component<Props, {error?: string; submitting: boolean}> {
  constructor(props: Props, context: any) {
    super(props, context)

    this.state = {error: undefined, submitting: false}
  }

  onSubmit = (fields: any) => {
    this.setState({error: undefined})

    if (!fields.name) {
      this.setState({error: 'Choose a name for your project'})
      return
    }
    if (!fields.evaluationDate) {
      this.setState({error: 'Choose an evaluation date for your project'})
      return
    }

    this.setState({submitting: true})

    this.callEndpoint(editProject, {
      name: fields.name,
      evaluationDate: fields.evaluationDate.unix() * 1000,
      projectId: this.props.projectId,
      customer: fields.customer || '',
      usersInvolved: fields.usersInvolved || []
    }).then(
      () => {
        this.setState({submitting: false})
        this.props.onUpdateNeeded()
        this.props.onRequestClose()
      },
      (error: any) => {
        this.setState(s => ({...s, error: error.message || 'Unauthorized', submitting: false}))
      },
    )
  }

  render() {
    const {props} = this
    let initialValues = undefined
    const projectData = getSnapshot(
      // @ts-ignore
      this.store.projects.baseProjectsById.get(props.projectId),
    )
    const store = this.store
    const users = getUsers(store)

    initialValues = {
      name: projectData.name,
      evaluationDate: moment(projectData.evaluationDate),
      customer: projectData.customer || '',
      usersInvolved: projectData.usersInvolved || [],
    }

    return (
      <GenericModal onHide={props.onRequestClose} css={{box: {container: css.box}}}>
        <Form onSubmit={this.onSubmit} initialValues={initialValues}>
          <TextInput.Field name="name" type="text" label="NAME" placeholder="Name of the project" />
          <TextInput.Field name="customer" type="text" label="CLIENT" placeholder="Client" />
          <DateInput.Field name="evaluationDate" label="DATE OF EVALUATION" />
          <MultiSelectInput.Field style="big" label="USERS INVOLVED" name="usersInvolved" options={users} />
          <div className={css.bottom}>
            {this.state.error && <div className={css.error}>Error occured: {this.state.error}</div>}
            <GenericButton variant="bold" type="submit" disabled={this.state.submitting}>
              EDIT PROJECT
            </GenericButton>
          </div>
        </Form>
      </GenericModal>
    )
  }
}

export const getUsers = (store: IStore) => {
  const {byId: usersById} = getSnapshot(store.users)

  const availableUsers = Object.keys(usersById)
    .map(id => usersById[id])
    .filter(({archived}) => archived !== true)
    .map(({_id, name}) => ({value: _id, label: name}))
  return availableUsers
}



// WEBPACK FOOTER //
// ./src/projects/EditProjectModal.tsx